import { DateHelper } from './../../../utils/date-helper';
import { SupportService } from './../../../data/repository/support-repository/support.service';
import { SettingService } from 'src/app/data/repository/setting-repository/setting.service';
import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { UpdateMessageResponce } from 'src/app/core/model/api-response/support-responce.model';
import { ActivatedRoute } from '@angular/router';
import { Subject, Subscription } from 'rxjs';

@Component({
  selector: 'app-message-page',
  templateUrl: './message-page.component.html',
  styleUrls: ['./message-page.component.scss'],
})
export class MessagePageComponent implements OnInit, OnDestroy {
  id: string;
  messages: UpdateMessageResponce;
  userReaction: 'noReaction' | 'like' | 'dislike';
  updateVote: Subject<string> = new Subject<string>();
  subscription: Subscription[] = [];
  constructor(
    private route: ActivatedRoute,
    private settingService: SettingService,
    private supportService: SupportService,
    private dateHelper: DateHelper
  ) {
    this.id = this.route.snapshot.paramMap.get('messageId');
    const vote = this.updateVote.subscribe((data) => {
      this.supportService
        .updateMessage(this.id, this.userReaction, true)
        .then((res) => {
          this.messages = res.getData().getUpdateMessageResponce();
          this.userReaction = this.messages.userReaction;
          console.log(this.messages);
        });
    });
    this.subscription.push(vote);
  }

  ngOnInit() {
    if (this.id) {
      this.supportService.updateMessage(this.id, null, true).then((res) => {
        this.messages = res.getData().getUpdateMessageResponce();
        this.userReaction = this.messages.userReaction;
      });
    }
    console.log(this.messages);
  }
  @HostListener('window:beforeunload')
  ngOnDestroy() {
    this.subscription.forEach((sb) => sb.unsubscribe());
  }
  back() {
    this.settingService.goBack();
  }
  getDate(date: Date) {
    return this.dateHelper.getYearAndMonthAndDayPersian(date);
  }
  vote(reaction: 'like' | 'dislike') {
    if (reaction == 'like') {
      if (this.userReaction == 'noReaction' || this.userReaction == 'dislike') {
        this.userReaction = 'like';
      } else if (this.userReaction == 'like') {
        this.userReaction = 'noReaction';
      }
    } else if (reaction == 'dislike') {
      if (this.userReaction == 'noReaction' || this.userReaction == 'like') {
        this.userReaction = 'dislike';
      } else if (this.userReaction == 'dislike') {
        this.userReaction = 'noReaction';
      }
    }
    this.updateVote.next(this.userReaction);
  }
}
